// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import AddTeam from '../addTeam';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import AddMember from '../addTournamentTeamMember';
import Dialog from 'material-ui/Dialog';
import Chip from 'material-ui/Chip';

class EditTournamentTeam extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id:props.match.params.id,
      teams: [],
      groups: [],
      game_types: [],
      team_details :{
        team:{
          id:'',
          name:'',
        },
        amount_paid:'',
        new_logo:{},
      },
      age_groups:[],
      addMemberView:false,
      data_uploaded: false,
      data_error: false,
      team_members:[],
      to_delete_member_list :[],
      showFullTeamDetails_list:[]
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getTeamList = this.getTeamList.bind(this);
    this.editTeamView = this.editTeamView.bind(this);
  }


  componentDidMount() {
    this.getaddTeamInputs();
    this.getTeamList();
    this.getTeamDetailInput();
    console.log(this.state);
  }
  getTeamDetailInput() {
     const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_tournament_team/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
         this.setState({  groups: data.groups,age_groups:data.age_groups});
        })
       .catch(error => error);
  } 

  getaddTeamInputs() {
     const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_team/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
         this.setState({game_types: data.game_types});
        })
       .catch(error => error);
  }
  postSaveTournamentTeam(data, props) {
    console.log('postSaveTournamentTeam')
      console.log(data)
      const url = `${getLocationOrigin()}/eagleeye/save_tournament_team_details/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                            'team_details': this.state.team_details,
                            'to_delete_member_list':this.state.to_delete_member_list,
                          });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then((response) => {                      // first then()
            alert(response.message);
            this.getTeamList();
            this.toAddTeamView();
            this.props.history.goBack();
            
          })
        .catch(error => {
          console.log(error);
          alert(error.message);
        });
    
  }

  getTeamList() {
        var mobile_no = this.state.mobile_no
        const url = `${getLocationOrigin()}/eagleeye/get_competition_team/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'id': this.state.id
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({team_details: data.teamlist}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }
    


  handleChange(event,team_id) {
    const name = event.target.name;
    const value = event.target.value
    var new_selected_one =  Object.assign({}, this.state.team_details);
        if(name == 'name'){
          new_selected_one.team.name = value
          this.setState({team_details: new_selected_one});
        }
        if(name == 'age_groups'){ 
          new_selected_one.age_groups = {'id':value,'name':name }
          this.setState({team_details: new_selected_one});
        }
        else{
          new_selected_one[name] = value
        }
        console.log(name,value)
    this.setState({team_details: new_selected_one});
    console.log(this.state)
  }
  handleFilelogo(selectorFiles: FileList){
    var new_selected_one =  Object.assign({}, this.state.team_details);
    console.log('Fileeeee');
    console.log(selectorFiles);
    new_selected_one['new_logo'] = selectorFiles[0]
    this.setState({team_details: new_selected_one});
  }
  
  toAddPlayerView(team){
    console.log(team.team[0],team.team[1])
    this.setState({team_name:team.team[1],team_id:team.team[0],addMemberView:!this.state.addMemberView})
  }
  editTeamView (team_id){
    this.setState({selected_team_id:team_id,showAllField:!this.state.showAllField});
    if(this.state.showAllField){
    this.getTeamList(); }
  }
  toAddPlayerView(team){
    console.log(team.team.id,team.team.name)
    this.setState({team_name:team.team.name,team_id:team.team.id,addMemberView:!this.state.addMemberView})
  }

  handleSubmit(event) {
    this.postSaveTournamentTeam(this.state.team_details, this.props);
  }
  toAddTeamView(){
    this.setState({addNewTeamView:!this.state.addNewTeamView});
  }
  handleRequestDelete(member){
      console.log(member)
      this.state.to_delete_member_list.push(member);
      var new_selected_one =  Object.assign({}, this.state.team_details);
      new_selected_one.players.pop(member);

      this.setState({team_details:new_selected_one});
      console.log(this.state.team_details.players)
  }
  handleBack(){
    this.props.history.goBack();
  }
  

  renderChip(data) {
    
    return (
      <Chip
        key={data.id}
        onRequestDelete={() => this.handleRequestDelete(data)}
        style={styles.chip}
      >
        {data.name}
      </Chip>
    );
  }

  render() {
    console.log('Teams')
    console.log(this.state)
    const deleteAction = [
        <input type="button" className="button1" value="Delete" style={{backgroundColor:'red',marginRight:'20px'}} onClick={() => {this.toDeleteTeam()}} />,
        <input type="button" className="button1" value="Cancel" onClick={() => {this.toDeleteView()}} />
      ];
    return(


      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Edit Team</h3>
          </div>
          <form  className="validated-form form-horizontal"  onSubmit={this.handleSubmit}>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Name
              </div>
              <div className="col-md-6" style={{width:'73%'}} >
                <input type="text" style={styles.input} name="name" value={this.state.team_details.team.name}  onChange={(e) => this.handleChange(e,this.state.team_details.id)}/>
              </div>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Category
              </div>
              <div className="col-md-6" style={{width:'73%'}} >
                  <select name="age_groups"  style={styles.item_body} value={this.state.value} 
                              onChange={(e) => this.handleChange(e,this.state.team_details.id)}>
                        {this.state.age_groups.map((x, index) => (
                            <option key={x.id} selected={this.state.team_details && this.state.team_details.age_groups && x.id == this.state.team_details.age_groups.id && x.id} value={x.id} >{ x.name}</option>
                          ))}
                  </select>
              </div>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Group
              </div>
              <div className="col-md-6" style={{width:'73%'}} >
              <select name="group"  style={styles.item_body} value={this.state.value} 
                                      onChange={(e) => this.handleChange(e,this.state.team_details.id)}>
                                      {
                                        this.state.groups.map((x, index) => (
                                        <option key={index} selected={this.state.team_details && this.state.team_details.group && x == this.state.team_details.group && x} value={x} >{ x}</option>
                                        ))
                                      }
                </select>
              </div>
            </div>

            {/*
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Amount Paid
              </div>
              <div className="col-md-6" style={{width:'73%'}}>
                <input type="number" style={styles.input} name="amount_paid" value={this.state.team_details.amount_paid} className="required"   onChange={(e) => this.handleChange(e,this.state.team_details.id)}/>
              </div>
            </div>
          */}

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                No. of Players
              </div>
              <div className="col-md-6" style={{width:'73%'}}>
                {this.state.team_details && this.state.team_details.no_of_players} 
              </div>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Player List
              </div>
              <div className="col-md-6" style={{width:'73%'}}>
                  <div style={styles.wrapper}>
                      {this.state.team_details.players && this.state.team_details.players.map(this.renderChip, this)}
                  </div>
                  <i className="far fa fa-user-plus" style={{fontSize:'25px',paddingLeft:'10px'}} onClick={() => {this.toAddPlayerView(this.state.team_details)}} />
              </div>

            </div>

            {this.state.team_details && this.state.team_details.team_type == 'TEAM' &&
              <div>
                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Logo
                  </div>
                  <div className="col-md-6" style={{width:'73%'}}>
                      <img id="logo" src={this.state.team_details && this.state.team_details.logo} alt="LOGO"/>
                  </div>
                </div>
                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    {this.state.team_details && this.state.team_details.logo ? "Change Logo":"Upload Logo"}
                  </div>
                  <div className="col-md-6 input-group" style={{width:'73%'}}>
                      <input type="file" style={styles.input} name="new_logo" onChange={ (e) => this.handleFilelogo(e.target.files) }/>
                  </div>
                </div>
              </div>
          }

            {this.state.addMemberView && 
                                  <div className="col-md-12">
                                      <AddMember team_id={this.state.id}  team_name={this.state.team_details.team.name} tournament_id={this.state.team_details.tournament}/>
                                  </div>
            }
            <div style={styles.button_submit} className="col-md-12">
              <input className="button1" type="submit" value="Update" />
              <input className="button1" type="button" value="Cancel" style={{backgroundColor:'red',marginLeft:'10px'}} onClick={() => this.handleBack()}/>
            </div>
            
          </form>
        </div>
      </div>
    );
  }
}

export default EditTournamentTeam;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editTournamentTeam/index.js